export type PostgresClientDisposition = "release" | "destroy";

function errorCode(error: unknown): string | undefined {
  if (!error || typeof error !== "object") {
    return;
  }
  const code = (error as { code?: unknown }).code;
  return typeof code === "string" ? code : undefined;
}

function errorMessage(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  return typeof error === "string" ? error : "";
}

/**
 * Decide whether a leased client may return to the pool.
 * Timed-out, reset, protocol-broken, or rollback-failed sessions are destroyed.
 * Ordinary SQL/transaction failures can be released after a successful ROLLBACK.
 */
export function classifyPostgresClientPoison(
  error: unknown
): PostgresClientDisposition {
  const code = errorCode(error);
  const message = errorMessage(error);

  if (
    code === "57014" ||
    code === "ETIMEDOUT" ||
    /statement timeout|query_timeout|connection timeout|deadline exceeded/i.test(
      message
    )
  ) {
    return "destroy";
  }

  if (
    code === "ECONNRESET" ||
    code === "ECONNREFUSED" ||
    code === "EPIPE" ||
    code === "ENOTCONN" ||
    code === "57P01" ||
    code === "57P02" ||
    code === "57P03" ||
    /connection terminated|server closed the connection|network reset/i.test(
      message
    )
  ) {
    return "destroy";
  }

  if (
    code === "08P01" ||
    code === "08P02" ||
    code === "08000" ||
    code === "08003" ||
    code === "08006" ||
    /protocol error|client_encoding|unexpected message/i.test(message)
  ) {
    return "destroy";
  }

  if (/rollback/i.test(message) && /fail/i.test(message)) {
    return "destroy";
  }

  return "release";
}
